export default __webpack_public_path__ + "static/media/test1.dc6bd629.jpg";